import moment from 'moment';
import store from 'mrf/redux/store.js';
import mrf from 'mrf.config';
import i18n from 'i18next';

const DEFAULT_FORMAT = 'L';

/**
 * Format a given date time according to user defined parameter.
 *
 * @param date or empty string if null is passed.
 */
export default function dateFormatter(date) {
    const systemParameters = store.getState()?.systemParameters;
    const dateFormatPattern = systemParameters?.DATE_FORMAT_PATTERN ?? DEFAULT_FORMAT;

    if (!date) {
        return '';
    }

    let m = moment(date);

    if (mrf.utc) {
        m = m.local();
    }

    if (mrf.useMomentLocale) {
        m = m.locale(i18n.language);
    }

    return m.format(mrf.useMomentLocale ? 'L' : dateFormatPattern)
}
